export default __webpack_public_path__ + "static/media/fpa20000.4c1b9c84.png";